<template>
  <div>
    <v-overlay :value="loading" opacity="0.7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <v-row>
        <v-col class="py-0" md="3" cols="12">
          <v-autocomplete
            class="py-0"
            :error-messages="errors.competencia_id"
            :items="competencias"
            :loading="isloadingCompetencia"
            :search-input.sync="searchAutoCompleteCompetencia"
            clearable
            dense
            hide-no-data
            hide-selected
            item-value="id"
            label="Competencias"
            outlined
            persistent-hint
            placeholder="Selecione a competência"
            v-model="formData.competencia_id"
            @change="loadDias"
          >
            <template v-slot:selection="data"> {{ data.item.mes }}/{{ data.item.ano }} </template>

            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title> {{ data.item.mes }}/{{ data.item.ano }} </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="py-0" md="3" cols="12">
          <v-autocomplete
            class="py-0"
            :error-messages="errors.dia_id"
            :items="dias"
            :loading="isloadingDia"
            :search-input.sync="searchAutoCompleteDia"
            clearable
            dense
            hide-no-data
            hide-selected
            item-text="data_dia"
            item-value="id"
            label="Dias"
            outlined
            persistent-hint
            placeholder="Selecione o dia"
            v-model="formData.dia_id"
            @change="loadVeiculos"
          >
            <template v-slot:selection="data">
              {{ data.item.data_dia | dateBR }}
            </template>

            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>
                  {{ data.item.data_dia | dateBR }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="py-0" md="6" cols="12">
          <v-autocomplete
            class="py-0"
            :error-messages="errors.orgao_id"
            :items="orgaos"
            :loading="isloadingOrgao"
            :search-input.sync="searchAutoCompleteOrgao"
            clearable
            dense
            hide-no-data
            hide-selected
            item-text="nome"
            item-value="id"
            label="Orgãos"
            outlined
            persistent-hint
            placeholder="Selecione o orgão"
            v-model="formData.orgao_id"
            @change="loadVeiculos"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <div v-if="veiculos.length">
        <v-row>
          <v-col v-for="veiculo in veiculos" :key="veiculo.id" md="6" cols="12">
            <ListVeiculo
              :dados="veiculoList(veiculo)"
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
// import { required } from '@/services/util/validate';
import frequenciaHttp from '@/services/http/resources/frota/frequenciaHttp';
import turnoHttp from '@/services/http/resources/frota/turnoHttp';
import orgaoHttp from '@/services/http/resources/configuracao/orgaoHttp';
import ListVeiculo from '@/views/private/frota/frequencia_secretaria/ListVeiculos.vue';

export default {
  name: 'FrequenciaForm',
  components: { ListVeiculo },
  data: () => ({
    valid: true,
    competencias: [],
    dias: [],
    veiculos: [],
    orgaos: [],
    formData: {
      competencia_id: '',
      dia_id: '',
      orgao_id: '',
    },
    formDataDefault: {
      competencia_id: '',
      dia_id: '',
      orgao_id: '',
    },
    // rules: {
    //   dia_id: [required],
    //   orgao_id: [required],
    // },
    errors: {
      dia_id: [],
      orgao_id: [],
    },
    loading: false,
    isloadingCompetencia: false,
    isloadingDia: false,
    isloadingOrgao: false,
    itemsAutoCompleteCompetencia: [],
    itemsAutoCompleteDia: [],
    itemsAutoCompleteOrgao: [],
    searchAutoCompleteCompetencia: '',
    searchAutoCompleteDia: '',
    searchAutoCompleteOrgao: '',
  }),
  mounted() {
    this.loadCompetencias();
    this.loadOrgaos();
    this.loadTurnos();
  },
  methods: {
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
        this.loadingSubmit = false;
      }
    },
    openDialog() {
      this.resetValidation();
      this.resetAutoComplete();
      this.loadCategoriasCnh();
      if (this.dataIndex > -1) {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          if (key === 'cgm_id' && this.data[key]) {
            this.formData[key] = this.data[key];
            this.itemsAutoCompletePessoa.push(this.data.pessoa);
          } else {
            this.formData[key] = this.data[key];
          }
        });
      }
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
        this.resetAutoComplete();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    loadCompetencias() {
      this.isloadingCompetencia = true;
      frequenciaHttp
        .listCompetencias()
        .then(({ data: { data } }) => {
          this.competencias = data;
        })
        .finally(() => {
          this.isloadingCompetencia = false;
        });
    },
    loadOrgaos() {
      this.isloadingOrgao = true;
      orgaoHttp
        .list()
        .then(({ data: { data } }) => {
          this.orgaos = data;
        })
        .finally(() => {
          this.isloadingOrgao = false;
        });
    },
    loadTurnos() {
      this.isloadingTurno = true;
      turnoHttp
        .list()
        .then(({ data: { data } }) => {
          this.turnos = data;
        })
        .finally(() => {
          this.isloadingTurno = false;
        });
    },
    loadDias() {
      if (this.formData.competencia_id) {
        this.isloadingDia = true;
        frequenciaHttp
          .listDias(this.formData.competencia_id)
          .then(({ data: { data } }) => {
            this.dias = data;
          })
          .finally(() => {
            this.isloadingDia = false;
          });
      }
    },
    loadVeiculos() {
      if (this.formData.dia_id && this.formData.orgao_id) {
        this.resetVeiculos();
        this.loading = true;
        frequenciaHttp
          .listVeiculos(this.formData.orgao_id, this.formData.dia_id)
          .then(({ data: { data } }) => {
            this.veiculos = data;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    resetAutoComplete() {
      this.itemsAutoCompletePessoa = [];
      this.searchAutoCompletePessoa = null;
      this.instituicoes = [];
      this.orgaos = [];
      this.perfis = [];
    },
    resetVeiculos() {
      this.veiculos = [];
    },
    veiculoList(veiculo) {
      return {
        veiculo,
        formData: this.formData,
        turnos: this.turnos,
      };
    },
  },
  watch: {
    dialogForm(value) {
      if (value) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    },
    'formData.dia_id': function () {
      this.errors.dia_id = [];
    },
    'formData.orgao_id': function () {
      this.errors.orgao_id = [];
    },
  },
};
</script>
